var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-introduction"},[_c('div',{staticClass:"introduce-part"},[_vm._v(" "+_vm._s(_vm.courseDesc.courseExplain && _vm.courseDesc.courseExplain)+" ")]),_c('Empty',{attrs:{"show":!_vm.courseDesc.courseExplain}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }